import { LOCAL_STORAGE_WL_KEY } from '../../../constants';
import { removeUndefined } from '../../../helpers';
import { sessionStorage } from '../../../helpers/storage';
import { clearUnauthorizedForm, encodeDataToB64, decodeDataFromB64 } from '../../../helpers/form.new';

interface WlSessionStorageItem {
    data?: string;
    expInMs?: string | number;
    userId?: number | string;
}

const WL_ITEM_TTL_IN_MINUTES = 30;

const clearSessionStorage = () => {
    clearWlStorageItem();
    clearUnauthorizedForm();
};

const isStorageItemNotExpired = (expirationTimeInMs = 0) => {
    return new Date().getTime() < expirationTimeInMs;
};

const getStorageItemExpirationTime = (): number => {
    return new Date().getTime() + WL_ITEM_TTL_IN_MINUTES * 60 * 1000;
};

export const saveWlAuthorizedForm = (data: FE.FormData, userId?: number | string) => {
    const fields = removeUndefined(data, [null, '']);
    const newItem: WlSessionStorageItem = {
        expInMs: getStorageItemExpirationTime(),
        data: JSON.stringify(fields),
        userId,
    };
    sessionStorage.setItem(LOCAL_STORAGE_WL_KEY, encodeDataToB64(newItem));
};

export const loadWlAuthorizedForm = (userId?: string | number): FE.FormData | null => {
    const raw = sessionStorage.getItem(LOCAL_STORAGE_WL_KEY);
    if (!raw) {
        return null;
    }

    try {
        const item = decodeDataFromB64<WlSessionStorageItem>(raw);
        if (!item) {
            clearSessionStorage();
            return null;
        }
        const { expInMs, data, userId: userIdFromItem } = item;
        if (
            !expInMs ||
            !data ||
            !isStorageItemNotExpired(Number(expInMs)) ||
            (typeof userId !== 'undefined' && userId != userIdFromItem)
        ) {
            clearSessionStorage();
            return null;
        }

        return JSON.parse(data) as FE.FormData;
    } catch (e) {
        console.error(e);
        return null;
    }
};

const clearWlStorageItem = () => {
    sessionStorage.removeItem(LOCAL_STORAGE_WL_KEY);
};

export const getUserIdFromWlStorageItem = (): string | null => {
    const raw = sessionStorage.getItem(LOCAL_STORAGE_WL_KEY);

    if (!raw) {
        return null;
    }

    try {
        const item = decodeDataFromB64<WlSessionStorageItem>(raw);
        if (!item) {
            clearSessionStorage();
            return null;
        }
        const { userId, expInMs } = item;
        if (isStorageItemNotExpired(Number(expInMs))) {
            return String(userId);
        } else {
            clearSessionStorage();
            return null;
        }
    } catch (e) {
        console.error(e);
        return null;
    }
};
